import { IGroupProp } from '@/utils/ctype';
import Blocker from '../../../components/Blocker';
import SubTitle from '../../../components/SubTitle/index';
import GroupTitle from '../../../components/GroupTitle';
import ChoiceQuestion from '../../../question/Question/ChoiceQuestion';
import DependentPairingQuestions from '../../../question/ReadingQuestion/DependentPairingQuestions';
import DependentPairingQuestionsAI from '../../../question/AIQuestion/DependentPairingQuestionsAI';
import SentenceParagraphInformationMatchingQuestion from '../../../question/ReadingQuestion/SentenceParagraphInformationMatchingQuestion';
import SentencePairingQuestions from '../../../question/ReadingQuestion/SentencePairingQuestions';
import SentencePairingQuestionsAI from '../../../question/AIQuestion/SentencePairingQuestionsAI';
import SummaryWithOptions from '../../../question/ReadingQuestion/SummaryWithOptions';
import SummaryWithOptionsAI from '../../../question/AIQuestion/SummaryWithOptionsAI';
import Completion from '../../../question/Question/Completion';
import PictureCompletion from '../../../question/Question/PictureCompletion';
import SentenceCompletion from '../../../question/Question/SentenceCompletion';
import MultipleQuestion from '../../../question/Question/MultipleQuestion';
import Table from '../../../question/Question/Table';
import style from './index.module.less';

export default function Group(props: IGroupProp) {
  const {data, currentFocus, saveAnswerHandle, answerMap, loadAnswered, pageData, isAI, index: keyIndex, setShowDragFieldHandle, setFocusIndexHandle, feedbackMap, displayAnswerMap} = props;

  const {answerAllText = []} = pageData;
  
  const {desc, type, list = [], group_id, title} = data || {};
  const createQuestions = (type: number) => {
    switch (type) {
      case 1: 
        return list.map((item, index: number) => {
          return <ChoiceQuestion displayAnswerMap={displayAnswerMap} feedbackMap={feedbackMap} type={type} data={item} groupId={group_id} key={index} currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} isJudge={true} keyIndex={keyIndex} index={index} answerAllText={answerAllText} setFocusIndexHandle={setFocusIndexHandle}></ChoiceQuestion>;
        });
      case 2: 
        if (isAI) {
          return <DependentPairingQuestionsAI displayAnswerMap={displayAnswerMap} feedbackMap={feedbackMap} type={type} data={data} groupId={group_id} currentFocus={currentFocus}
            saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI}
            loadAnswered={loadAnswered} keyIndex={keyIndex} answerAllText={answerAllText}
          ></DependentPairingQuestionsAI>;
        } else {
          return <DependentPairingQuestions displayAnswerMap={displayAnswerMap} type={type} data={data} groupId={group_id} currentFocus={currentFocus}
            saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} loadAnswered={loadAnswered}
            keyIndex={keyIndex} setShowDragFieldHandle={setShowDragFieldHandle} setFocusIndexHandle={setFocusIndexHandle}></DependentPairingQuestions>;

        }
      case 3:
        return <SentenceParagraphInformationMatchingQuestion displayAnswerMap={displayAnswerMap} feedbackMap={feedbackMap} type={type} data={data} groupId={group_id} currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} keyIndex={keyIndex} answerAllText={answerAllText} setFocusIndexHandle={setFocusIndexHandle}></SentenceParagraphInformationMatchingQuestion>;
      case 4:
        // return <SummaryWithoutOptionsQuestions type={type} data={data} groupId={group_id} loadAnswered={loadAnswered}></SummaryWithoutOptionsQuestions>;
        return <>
          <Blocker>
            <GroupTitle title={title} />
            <SentenceCompletion displayAnswerMap={displayAnswerMap} feedbackMap={feedbackMap} type={type} data={data} groupId={group_id} currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} keyIndex={keyIndex} answerAllText={answerAllText} setFocusIndexHandle={setFocusIndexHandle}></SentenceCompletion>
          </Blocker>
        </>;
      case 5: 
        return list.map((item, index: number) => {
          return <ChoiceQuestion displayAnswerMap={displayAnswerMap} feedbackMap={feedbackMap} type={type} data={item} groupId={group_id} key={index} currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} keyIndex={keyIndex} index={index} answerAllText={answerAllText} setFocusIndexHandle={setFocusIndexHandle}></ChoiceQuestion>;
        });
        // return <SentenceCompletion type={type} data={data} groupId={group_id} ></SentenceCompletion>;
      case 6: 
        return null;
        // return <ImgCompletion type={type} data={data} groupId={group_id}></ImgCompletion>;
      case 7 :
        return <MultipleQuestion displayAnswerMap={displayAnswerMap} feedbackMap={feedbackMap} type={type} data={data} groupId={group_id} currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} keyIndex={keyIndex} answerAllText={answerAllText} setFocusIndexHandle={setFocusIndexHandle}></MultipleQuestion>;
      case 8:
        return <Blocker>
          <GroupTitle title={title} />
          <SentenceCompletion displayAnswerMap={displayAnswerMap} feedbackMap={feedbackMap} type={type} data={data} groupId={group_id} currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} keyIndex={keyIndex} answerAllText={answerAllText} setFocusIndexHandle={setFocusIndexHandle}></SentenceCompletion>
        </Blocker>;
        // return <SummaryWithoutOptionsQuestions data={data} groupId={group_id} currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} loadAnswered={loadAnswered}></SummaryWithoutOptionsQuestions>;
      case 9: 
        // return <div>123</div>;
        if (isAI) {
          return <SentencePairingQuestionsAI displayAnswerMap={displayAnswerMap} feedbackMap={feedbackMap} type={type} data={data} groupId={group_id} currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} loadAnswered={loadAnswered} keyIndex={keyIndex} answerAllText={answerAllText}></SentencePairingQuestionsAI>;
        } else {
          return <SentencePairingQuestions displayAnswerMap={displayAnswerMap} type={type} data={data} groupId={group_id} currentFocus={currentFocus} 
            saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} loadAnswered={loadAnswered}
            keyIndex={keyIndex} setShowDragFieldHandle={setShowDragFieldHandle}
            setFocusIndexHandle={setFocusIndexHandle}></SentencePairingQuestions>;
        }
        
      case 10:
        if (isAI) {
          return <>
            <SummaryWithOptionsAI displayAnswerMap={displayAnswerMap} feedbackMap={feedbackMap} type={type} data={data} groupId={group_id} currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} loadAnswered={loadAnswered} keyIndex={keyIndex} answerAllText={answerAllText}></SummaryWithOptionsAI>
          </>;

        } else {
          return <>
            <SummaryWithOptions displayAnswerMap={displayAnswerMap} feedbackMap={feedbackMap} type={type} data={data} groupId={group_id} currentFocus={currentFocus}
              saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} loadAnswered={loadAnswered}
              keyIndex={keyIndex} setShowDragFieldHandle={setShowDragFieldHandle}
              setFocusIndexHandle={setFocusIndexHandle}></SummaryWithOptions>
          </>;

        }
      case 11: 
        return (
          <div>
            {
              list.map((item, index: number) => {
                // return <ShortAnswerQuestions type={type} data={item} groupId={group_id} key={index}></ShortAnswerQuestions>;
                return <Completion displayAnswerMap={displayAnswerMap} feedbackMap={feedbackMap} type={type} data={item} groupId={group_id} key={index} currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} keyIndex={keyIndex} index={index} answerAllText={answerAllText} setFocusIndexHandle={setFocusIndexHandle}></Completion>;
              })
            }
          </div> 
        );
      case 12: 
        // return <ImgCompletion data={data} groupId={group_id} currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} loadAnswered={loadAnswered}></ImgCompletion>;
        return <PictureCompletion displayAnswerMap={displayAnswerMap} feedbackMap={feedbackMap} type={type} data={data} groupId={group_id} currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} keyIndex={keyIndex} answerAllText={answerAllText} setFocusIndexHandle={setFocusIndexHandle}></PictureCompletion>;
      case 13: 
        return <Table displayAnswerMap={displayAnswerMap} inputClass={style.readInputClass} data={data} type={type} groupId={group_id} currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} keyIndex={keyIndex} answerAllText={answerAllText} setFocusIndexHandle={setFocusIndexHandle} feedbackMap={feedbackMap}></Table>;
    }
  };
  return (
    <div className={style.answerGroup}>
      <SubTitle desc={desc} keyIndex={keyIndex} staticWidth={type === 1}></SubTitle>
      <div className='row'>
        {createQuestions(type)}
      </div> 
    </div>
  );
}